
const FieldActivityRemarks = {
    "REMOVED": "PWREMC",
    "DELIVERED": "PWDELCON",
    "REPAIRED": "PWREPA",
    "REPLACED": "PWREPL",
    "CONTAINER_NOT_OUT": "PWCNOUT",
    "FOREMAN_INVESTIGATE": "FI",
    "DONE": "PWADONE"
};

export default FieldActivityRemarks;